import {useEffect, useState} from "react";
import {searchInit} from "../../list/init/searchInit";
import {useMutation} from "@tanstack/react-query";
import {paginationInit} from "../../../../common/init/PaginationInit";
import useGoToNavigation from "../../../../../util/useGotoNavigation";
import PaginationSub from "../../../../../components/common/pagination/PaginationSub";
import { readDutyGroupMemberApi } from "../../../../../api/manage/role/DutyGroupApi";
import { useParams } from "react-router-dom";
import { RolesUserInterface } from "../../list/interface/RolesUserInterface";

export const RoleUsers = () => {
    const {goToNavigation} = useGoToNavigation();

    const [searchData, setSearchData] = useState<RolesUserInterface[]>([]);
    const [dataCount, setDataCount] = useState(0);
    const [searchParam, setSearchParam] = useState(searchInit)
    const [allChecked, setAllChecked] = useState(false);
    const [checkedItems, setCheckedItems] = useState<Set<string>>(new Set());
    const [currentPage, setCurrentPage] = useState(paginationInit);
    const {id} = useParams<{ id: string }>();

    const handleAllCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const isChecked = e.target.checked;
        setAllChecked(isChecked);
        setCheckedItems(new Set(isChecked ? searchData.map((item: any) => item.accountId) : []));
    };

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>, accountId: string) => {
        const newCheckedItems = new Set(checkedItems);
        e.target.checked ? newCheckedItems.add(accountId) : newCheckedItems.delete(accountId);
        setCheckedItems(newCheckedItems);
        setAllChecked(newCheckedItems.size === searchData.length);
    };

    const readDutyGroupMemberApiMutate = useMutation({
        mutationFn: () => readDutyGroupMemberApi({...searchParam, dutyGroupId : Number(id)}),
        onSuccess: res => {
            if (res.data.code === "0000") {
                setSearchData(res.data.result?.userList ?? []);
                setDataCount(res.data.result?.totalCount ?? 0)
            } else {
            }
        },
        onError: res => {
            alert(res)
        }
    });

    useEffect(()=>{
        readDutyGroupMemberApiMutate.mutate()
    },[])

    useEffect(() => {
        readDutyGroupMemberApiMutate.mutate()
    }, [searchParam.pageNo])

    useEffect(() => {
        setSearchParam({...searchParam, pageNo: currentPage.page})
    }, [currentPage.page])

    return (
        <>
            <div className="fiter_wrap">
                <div className="fiter_top">
                    <h3 className="filter_heading">구성원 검색</h3>
                    <div className="filter_toolbar"></div>
                </div>
                <div className="row">
                    <div className="col-6">
                        <div className="frm_row search justify-content-start">
                            <label htmlFor="" className="form-label frm_label">검색어</label>
                            <select className="form-select"
                                    onChange={(e) => setSearchParam({...searchParam, keywordType: e.target.value})}>
                                <option value={'0'}>전체</option>
                                <option value={'1'}>이름</option>
                                <option value={'2'}>ID</option>
                                <option value={'3'}>회사명</option>
                            </select>
                            <input type="text"
                                   className="form-control"
                                   onChange={(e) => setSearchParam({...searchParam, keyword: e.target.value})}
                                   onKeyDown={e => e.key === "Enter" ? readDutyGroupMemberApiMutate.mutate() : ""}
                            />
                            <button className="btn btn-info btn_search"
                                    onClick={() => readDutyGroupMemberApiMutate.mutate()}>
                                <img src={process.env.PUBLIC_URL + "/assets/images/icon_search.png"} alt=""/>조회
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div className="content_wrap">
                <div className="table_top">
                    <h6 className="table_stats">구성원 목록(<span>{dataCount}</span>건)</h6>
                </div>

                <div className="table_scroll">
                    <table className="table table-bordered my_table">
                        <thead>
                        <tr>
                            <th>No</th>
                            <th>ID</th>
                            <th>이름</th>
                            <th>직함</th>
                            <th>회사명</th>
                            <th>부서</th>
                            <th>팀</th>
                        </tr>
                        </thead>
                        <tbody>
                        {searchData && searchData.length > 0 ? (
                            searchData.map((item, index) => (
                                <tr key={item.userId}
                                    onClick={() => goToNavigation(`manage/account/detail/${item.userId}`, "", false)}>
                                    <td className="text-center">{(currentPage.page - 1) * 10 + index + 1}</td>
                                    <td>{item.loginId || "-"}</td>
                                    <td className="text-center">{item.userName || "-"}</td>
                                    <td className="text-center">{item.title || "-"}</td>
                                    <td className="text-center">{item.companyName || "-"}</td>
                                    <td className="text-center">{item.departmentName || "-"}</td>
                                    <td className="text-center">{item.teamName || "-"}</td>
                                </tr>
                            ))
                        ) : (
                            <tr>
                                <td colSpan={6} className="text-center">데이터가 없습니다.</td>
                            </tr>
                        )}
                        </tbody>
                    </table>
                </div>

                <PaginationSub
                    totalCount={dataCount ?? 0}
                    currentPage={currentPage.page}
                    onChangeCallback={(i: number) => setCurrentPage({page: i})}
                />
            </div>
        </>
    );
}